"use client";
import { alchemyMainnetUrl } from "@/utils/alchemy";
// import { configParts } from "@/components/WagmiProvider";
import { PrivyProvider } from "@privy-io/react-auth";
import { WagmiProvider } from "@privy-io/wagmi";
import { createConfig } from "@privy-io/wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { mainnet } from "viem/chains";
import { http } from "wagmi";

const config = createConfig({
  chains: [mainnet], // Pass your required chains as an array
  transports: {
    [mainnet.id]: http(alchemyMainnetUrl)
  }
});

export default function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = new QueryClient();

  return (
    <PrivyProvider
      appId={process.env.NEXT_PUBLIC_PRIVY_ID!}
      config={{
        appearance: {
          theme: "light",
          accentColor: "#FF4517"
        }
      }}>
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={config}>{children}</WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  );
}
